import { render, staticRenderFns } from "./target-response-times-grid.vue?vue&type=template&id=5674d4fb&scoped=true&"
import script from "./target-response-times-grid.ts?vue&type=script&lang=ts&"
export * from "./target-response-times-grid.ts?vue&type=script&lang=ts&"
import style0 from "./target-response-times-grid.scss?vue&type=style&index=0&id=5674d4fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674d4fb",
  null
  
)

export default component.exports